import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=67fe654f&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"
import style0 from "./Subscription.vue?vue&type=style&index=0&id=67fe654f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe654f",
  null
  
)

export default component.exports